import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/sales/analyst", {
    sort: "tran_date,desc",
    ...params,
  });
};

export const exportCsv = async (params) => {
  return await fetchFinance("/sales/analyst", {
    output: "csv",
    ...params,
  });
};

export const querySales = async (params) => {
  return await fetchFinance("/action", {
    action: "getSales",
    ...params,
  });
};
